import React from 'react';
import { EyeOff, X } from 'lucide-react';
import { useUser } from '../context/UserContext';

export default function ViewAsBanner() {
    const { simulatedRole, clearViewAsRole, realUser } = useUser();
    if (!simulatedRole || realUser?.role !== 'admin') return null;

    return (
        <div
            data-testid="view-as-banner"
            className="fixed top-0 left-0 right-0 z-[60] bg-amber-500 text-slate-950 text-xs sm:text-sm font-bold px-4 py-1.5 flex items-center justify-center gap-3 shadow-md"
        >
            <EyeOff className="w-3.5 h-3.5" />
            <span className="uppercase tracking-wider">Admin Preview · Viewing as <strong>{simulatedRole}</strong></span>
            <button
                onClick={clearViewAsRole}
                className="ml-2 inline-flex items-center gap-1 bg-slate-950/10 hover:bg-slate-950/20 rounded-full px-2 py-0.5 text-[10px] uppercase tracking-wider transition-colors"
            >
                <X className="w-3 h-3" /> Exit
            </button>
        </div>
    );
}
